import React from 'react';
import HousinGramLogo from '../../assets/svg/Logo.svg';
import LoginFormFooter from '../forms/LoginFormFooter';

const AuthFormShell = ({ title, subtitle, children }) => {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-md flex-col">
      <div className="flex flex-col items-center gap-1 pt-2">
        <img src={HousinGramLogo} alt="HousinGram" className="h-11 w-auto" />
        <p className="text-center text-xs text-gray-500">
          Complete Real Estate Business Management Platform
        </p>
      </div>

      <div className="flex flex-1 flex-col justify-center gap-6 py-8">
        <div className="flex flex-col gap-2 text-center">
          <h1 className="text-2xl font-semibold text-stone-800">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
        </div>

        {children}
      </div>

      <LoginFormFooter />
    </div>
  );
};

export default AuthFormShell;
